import { useMutation } from '@apollo/client';
import styled from "@emotion/styled";
import React, { useEffect, useState } from 'react';
import { useFunnelNavigate } from 'src/common/hooks/useFunnelNavigate.hook';
import { i18n, mediaQuery, openCallMeModal, setProgressBarPercentage, useAppDispatch, useAppSelector } from 'src/common';
import { setPaymentAttempt, setPaymentError } from 'src/common/api/apollo/supplementary';
import { Button, Flex, StatusMessage } from 'src/components';
import { footer, header } from 'src/theme';
import { AppRoutes } from '../../_router/app.routes';

const ButtonContainerStyle = styled.div({
  marginTop: 32,
  textAlign: 'center',
})

const ButtonStyle = styled(Button)({
  [mediaQuery('mobile')]: {
    marginRight: 24,
  }
})

const FlexStyle = styled(Flex)({
  minHeight: `calc(100vh - ${footer.mobileHeight + header.mobileHeight + 80}px)`,

  [mediaQuery('mobile')]: {
    minHeight: `calc(100vh - ${footer.height + header.mobileHeight + 80}px)`,
  },

  [mediaQuery('laptopL')]: {
    minHeight: `calc(100vh - ${footer.height + header.height + 80}px)`,
  },
});

const CheckoutFailurePage = () => {
  const dispatch = useAppDispatch();
  const navigate = useFunnelNavigate();

  const offerId = useAppSelector((store) => store.model.offer.offerId);

  const [errors, setErrors] = useState<string | null>(null);

  useEffect(() => {
    dispatch(setProgressBarPercentage(0));
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    setErrors(queryParams.get('ErrorCodes'));
  }, []);

  const [setPaymentAttemptMutation] = useMutation(setPaymentAttempt);
  const [setPaymentErrorMutation] = useMutation(setPaymentError);

  useEffect(() => {
    if (offerId && errors) {
      setPaymentAttemptMutation({
        variables: { id: offerId }
      });

      setPaymentErrorMutation({
        variables: { offerId, input: { errorCodes: errors } }
      });
    }
  }, [errors, offerId, setPaymentAttemptMutation, setPaymentErrorMutation]);

  const Buttons = () => (
    <ButtonContainerStyle>
      <ButtonStyle btnType='primary' onClick={() => navigate(`${AppRoutes.CHECKOUT.fullPath}/${offerId}`)}>
        {i18n.t('pages.checkoutFailurePage.tryAgainButton')}
      </ButtonStyle>
      <Button btnType='textBlack' onClick={() => dispatch(openCallMeModal())}>
        {i18n.t('pages.checkoutFailurePage.requestCallButton')}
      </Button>
    </ButtonContainerStyle>
  );

  return (
    <FlexStyle justify='center' align='center'>
      <StatusMessage buttons={<Buttons />} title={i18n.t('pages.checkoutFailurePage.title')} subtitle={i18n.t('pages.checkoutFailurePage.subtitle')} />
    </FlexStyle>
  );
}

export default CheckoutFailurePage;
